import { ref } from "vue";
import { mapPointsPerTyresToSurchargeTable } from "@/data/portal_surcharge_table_mappers";
import { PointsPerTyresService } from "@/services/points-per-tyres.service";

export function usePortalSurchargeTable() {
  const columns = ref([]);
  const rows = ref([]);
  const loading = ref(true);

  async function loadSurchargeTable() {
    loading.value = true;

    try {
      const data = await PointsPerTyresService.list();
      const mapped = mapPointsPerTyresToSurchargeTable(
        Array.isArray(data) ? data : null,
      );

      if (mapped) {
        columns.value = mapped.columns;
        rows.value = mapped.rows;
      } else {
        columns.value = [];
        rows.value = [];
      }
    } catch (error) {
      console.warn("Portal surcharge table API unavailable.", error);
      columns.value = [];
      rows.value = [];
    } finally {
      loading.value = false;
    }
  }

  return {
    columns,
    rows,
    loading,
    loadSurchargeTable,
  };
}
